import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
export function IconSelect(t0) {
  const $ = _c(4);
  const {
    testId
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M0 8.1875H8.25L4.125 13L0 8.1875Z" fill="currentColor" />;
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M0 4.8125H8.25L4.125 0L0 4.8125Z" fill="currentColor" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== testId) {
    t3 = <svg width="9" height="13" viewBox="0 0 9 13" data-testid={testId}>{t1}{t2}</svg>;
    $[2] = testId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}